import { axiosClient } from '../utils/axiosClient.js';
import * as Paths from '@/components/common/paths';
import { handleServerError } from '@/components/common/errorUtils';
import i18n from '@/i18n';

// 翻訳キーから値を取得するヘルパー関数
const t = (key) => {
    try {
        return i18n.global.t(key);
    } catch (e) {
        return '';
    }
};

const actions = {

    async targetDates(_, operator_id) {
        try {
            const response = await axiosClient.get(`${Paths.HISTORYDATE_URL}${operator_id}`);
            const data = response.data;

            if (data.type === 0) {
                return { success: true, result: data.result };
            } else {
                console.error('History data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.target_date_fetch_failed') };
        }

    },
    async select(_, val) {
        try {
            const response = await axiosClient.post(`${Paths.HISTORY_URL}${val.operator_id}`, val);
            const data = response.data;

            if (data.type === 0) {
                return { success: true, result: data.result };
            } else {
                console.error('History data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.history_fetch_failed') };
        }
    },

    async getReportData(_, id) {
        try {
            const response = await axiosClient.get(`${Paths.REPORT_DATA_URL}${id}`);
            const data = response.data;

            if (data.type === 0) {
                return data.result.report_data;
            } else {
                console.error('History data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.history_fetch_failed') };
        }
    },

    async getOf5Data(_, id) {
        try {
            const response = await axiosClient.get(`${Paths.ORAL_FRAILTY_EXPLANATION_URL}${id}`);
            const data = response.data;

            if (data.type === 0) {
                return data.result;
            } else {
                console.error('History data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.history_fetch_failed') };
        }
    },

    async getS3(_, paramsS3) {
        try {
            const response = await axiosClient.post(`${Paths.GET_S3_URL}`, paramsS3);
            const data = response.data;

            if (data.type === 0) {
                return { success: true, binaryData: data.binaryData };
            } else {
                console.error('Unexpected data type:', data.type);
                return { success: false, error: 'Unexpected data type' };
            }
        } catch (error) {
            console.error(handleServerError(error));
            return { success: false, error: t('errors.s3_upload_failed') };
        }
    },
};

export default {
    namespaced: true,
    actions,
};
